export default {
    computed: {
        filteredFirmen: function () {    
            let mixinFirmen = this.firmen
            if (this.$store.getters.preFilteredFirmen.length) {
                mixinFirmen = this.$store.getters.preFilteredFirmen
            }
            return mixinFirmen.filter((firma) => {
                return firma.name.match(this.$store.getters.search);
            })           
        },
        filteredMarken: function() {
            let mixinMarken = this.marken
            if (this.$store.getters.preFilteredMarken.length) {
                mixinMarken = this.$store.getters.preFilteredMarken
            }
            return mixinMarken.filter((marke) => {
                return marke.name.match(this.$store.getters.search);
            })
        },
        filteredAdressen: function() {
            return this.adressen.filter((adresse) => {
                return adresse.strasse.match(this.$store.getters.search) ||
                        adresse.ort.match(this.$store.getters.search);
            })
        },
       
    }
}



// WEBPACK FOOTER //
// ./src/mixins/searchMixin.js